module.exports = __webpack_public_path__ + "static/img/图层2.029459c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层2.png
// module id = jmAW
// module chunks = 0